import { render, staticRenderFns } from "./manageInheritanceRecord.vue?vue&type=template&id=9f2da3e0&scoped=true&"
import script from "./manageInheritanceRecord.vue?vue&type=script&lang=js&"
export * from "./manageInheritanceRecord.vue?vue&type=script&lang=js&"
import style0 from "./manageInheritanceRecord.vue?vue&type=style&index=0&id=9f2da3e0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f2da3e0",
  null
  
)

export default component.exports